export const CREATING_PAGE = "CREATING_PAGE";
export const UPDATING_PAGE = "UPDATING_PAGE";
export const PAGE_CREATED = "PAGE_CREATED";
export const PAGE_UPDATED = "PAGE_UPDATED";
export const ERROR_PAGE_CREATE = "ERROR_PAGE_CREATE";
export const ERROR_PAGE_UPDATE = "ERROR_PAGE_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
